import dayjs from "dayjs";

const getDayOfWeekNumber = dateString => {
  const dayjsDate = dayjs(dateString, "YYYY-MM-DD");
  return dayjsDate.day();
};

export default getDayOfWeekNumber;
